export default {
    CREATE : 'CREATE',
    UPDATE : 'UPDATE',
    CANCEL : 'CANCEL'
}